import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	sliders: [],
};

// active account slice
export const allSlidersSlice = createSlice({
	name: 'sliders',
	initialState,
	reducers: {
		setAllSliders: (state, action) => {
			state.sliders = action.payload;
		},
	},
});

export const {
	setAllSliders,
} = allSlidersSlice.actions;

export default allSlidersSlice.reducer;
